import { Component, EventEmitter, Inject, Injectable, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { Agency } from '../../../../core/models/agency';
import { User } from '../../../../core/models/user';

@Component({
  selector: 'trade-desk',
  templateUrl: './trade-desk.component.html',
  styleUrls: ['./trade-desk.component.scss']
})
export class TradeDeskComponent implements OnInit, OnDestroy {
  existingIntegrations = [];
  createdIntegration: any = {};
  creating = false;
  accounts = [];
  adAccount: any;
  agency: Agency = {} as any;
  brand;
  loading = false;
  saving = false;
  isAdmin = false;
  emitter: EventEmitter<any>;
  integrationType;
  user: User;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TradeDeskComponent>,
    private integrationDao: IntegrationDao
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    this.agency = this.data.agency;
    this.brand = this.data.brand;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.emitter = this.data.emitter;
    this.integrationType = this.data.type;
    if (!this.existingIntegrations || !(this.existingIntegrations.length > 0)) {
      this.addAnother(null);
    }
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  addAnother(e) {
    if (!this.accounts || !(this.accounts.length > 0)) {
      this.loading = true;
      // this.integrationDao.getTradeDeskAccounts(this.agency.id).subscribe(res => {
      //   this.accounts = res;
      //   this.loading = false;
      // });
    }
    this.creating = true;
  }

  save(e) {
    this.saving = true;
    let selectedAdvertiser = this.accounts.find(acct => acct.AdvertiserId === this.adAccount);
    this.createdIntegration.friendlyName = selectedAdvertiser.AdvertiserName;
    this.createdIntegration.token = this.agency.tradeDeskToken;
    this.createdIntegration.partnerId = this.agency.tradeDeskPartnerId;
    this.createdIntegration.advertiserId = this.adAccount;
    this.createdIntegration.type = 'trade-desk';
    this.createdIntegration.brand = this.brand;
    // this.integrationDao.createIntegration(this.createdIntegration).subscribe(
    //   res => {
    //     this.createdIntegration.id = res.id;
    //     this.createdIntegration.enabled = res.enabled;
    //     this.saving = false;
    //     this.dialogRef.close(this.createdIntegration);
    //   },
    //   err => console.error(err)
    // );
  }
}
